import { render } from "./client_list.vue?vue&type=template&id=40595cf1"
import script from "./client_list.vue?vue&type=script&lang=js"
export * from "./client_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__